<script>

	import SignUp from '@/components/SignUp/SignUp'

	import './style.scss'

	export default {
		name: 'hero',
		components: {
			SignUp,
		}
	}

</script>

<template>
	<div class='hero'>
		<div class='container'>
			<div class='slogan'>
				<h1>
					Study recent interview questions from top tech companies
				</h1>
				<p>Prepare for your next interview properly by knowing exactly what to expect.</p>
			</div>
			<SignUp />
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Hero/Hero.vue